export const homePaths = {
    INDEX: '/',
    COMMENTS: '/comments',
    DONE: '/done',
}